module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAKCAYAAADPcbwqAAAAnElEQVQ4jdXTPw4BQRhA8bfbKESicgCFzkE0amfZai/CFShUbqDQKBxDoZenMGLI7tJ9vGoy+Ypf5g90pNbqUu11zf1E6txne3UUbWpNnaiXDHxU+9GuxtSBesqwZ3Uc7WpMLdR1hr2qs2hXa2rla1W06b3isUgnuQXKtLUDFoABrtYKgPRGD8AwlvO5Mv3+DX+Ahfv1r4BpNOTbbiMQf1512QD/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/white_left.png
// module id = ki26
// module chunks = 1